import { createApp } from 'vue'
import StafetDeltagSomFighterFlow from './StafetDeltagSomFighterFlow'
import isObjectNotNullOrEmpty from 'foundation/js/isObjectNotNullOrEmpty'

const el = '.kb-component--stafet-deltag-som-fighter-flow'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDeltagSomFighterFlowDOM) => {
            const externalData = StafetDeltagSomFighterFlowDOM.dataset.external
                ? JSON.parse(StafetDeltagSomFighterFlowDOM.dataset.external)
                : null
            const props = {
                stafetId: externalData.stafetId ?? null,
                tshirtSizes: externalData.tshirtSizes ?? [],
                holdList: externalData.holdList ?? [],
                userData: isObjectNotNullOrEmpty(externalData.userData)
                    ? externalData.userData
                    : null,
                donationAmounts: externalData.amounts ?? [],
                loggedIn: isObjectNotNullOrEmpty(externalData.userData),
                redirectToEditProfile:
                    StafetDeltagSomFighterFlowDOM.dataset
                        .redirectToEditProfile ?? '',
                adultPrice: externalData.adultPrice,
                childPrice: externalData.childPrice,
                redirectToEditProfile: externalData.redirectToEditProfile,
                editProfileLinkText: externalData.editProfileLinkText
            }

            const component = createApp(StafetDeltagSomFighterFlow, props).use(
                Store
            )

            component.mount(StafetDeltagSomFighterFlowDOM)
        })
    }
}
